// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { RadioButtonController } from '@/game/prefabs/RadioButton/RadioButtonController';
/* END-USER-IMPORTS */

export default class RadioButton extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// button
		const button = scene.add.image(0, 0, "radio off");
		button.scaleX = 4;
		button.scaleY = 4;
		button.setOrigin(0, 0.5);
		this.add(button);

		// settingLabel
		const settingLabel = scene.add.bitmapText(60, 0, "Aronui", "Radio Button");
		settingLabel.setInteractive(new Phaser.Geom.Rectangle(0, -15, 160, 60), Phaser.Geom.Rectangle.Contains);
		settingLabel.setOrigin(0, 0.5);
		settingLabel.tintTopLeft = 5387071;
		settingLabel.tintTopRight = 5387071;
		settingLabel.tintBottomLeft = 5387071;
		settingLabel.tintBottomRight = 5387071;
		settingLabel.text = "Radio Button";
		settingLabel.fontSize = -24;
		this.add(settingLabel);

		// tooltipDisabledCover
		const tooltipDisabledCover = scene.add.image(0, 0, "1x1sprite");
		tooltipDisabledCover.setInteractive(new Phaser.Geom.Rectangle(0, 0, 1, 1), Phaser.Geom.Rectangle.Contains);
		tooltipDisabledCover.scaleX = 500;
		tooltipDisabledCover.scaleY = 64;
		tooltipDisabledCover.setOrigin(0, 0.5);
		tooltipDisabledCover.alpha = 0.00001;
		tooltipDisabledCover.alphaTopLeft = 0.00001;
		tooltipDisabledCover.alphaTopRight = 0.00001;
		tooltipDisabledCover.alphaBottomLeft = 0.00001;
		tooltipDisabledCover.alphaBottomRight = 0.00001;
		this.add(tooltipDisabledCover);

		// interactionHitbox
		const interactionHitbox = scene.add.image(0, -24, "1x1sprite");
		interactionHitbox.scaleX = 500;
		interactionHitbox.scaleY = 48;
		interactionHitbox.setOrigin(0, 0);
		interactionHitbox.alpha = 0.00001;
		interactionHitbox.alphaTopLeft = 0.00001;
		interactionHitbox.alphaTopRight = 0.00001;
		interactionHitbox.alphaBottomLeft = 0.00001;
		interactionHitbox.alphaBottomRight = 0.00001;
		this.add(interactionHitbox);

		// settingTooltip
		const settingTooltip = scene.add.container(240, -32);
		settingTooltip.visible = false;
		this.add(settingTooltip);

		// tooltipBacking
		const tooltipBacking = scene.add.nineslice(0, 0, "Hud2", undefined, 116, 32, 10, 10, 10, 10);
		tooltipBacking.scaleX = 4;
		tooltipBacking.scaleY = 4;
		tooltipBacking.setOrigin(0, 0);
		settingTooltip.add(tooltipBacking);

		// tooltipText
		const tooltipText = scene.add.bitmapText(80, 12, "Aronui", "Explanation of what this setting does.");
		tooltipText.tintTopLeft = 5387071;
		tooltipText.tintTopRight = 5387071;
		tooltipText.tintBottomLeft = 5387071;
		tooltipText.tintBottomRight = 5387071;
		tooltipText.text = "Explanation of what this setting does.";
		tooltipText.fontSize = -24;
		tooltipText.maxWidth = 386;
		settingTooltip.add(tooltipText);

		// helpIcon
		const helpIcon = scene.add.image(40, 64, "help3");
		helpIcon.scaleX = 4;
		helpIcon.scaleY = 4;
		settingTooltip.add(helpIcon);

		this.button = button;
		this.settingLabel = settingLabel;
		this.tooltipDisabledCover = tooltipDisabledCover;
		this.interactionHitbox = interactionHitbox;
		this.tooltipBacking = tooltipBacking;
		this.tooltipText = tooltipText;
		this.helpIcon = helpIcon;
		this.settingTooltip = settingTooltip;

		/* START-USER-CTR-CODE */

    this._controller = new RadioButtonController(this);

    /* END-USER-CTR-CODE */
	}

	public button: Phaser.GameObjects.Image;
	public settingLabel: Phaser.GameObjects.BitmapText;
	public tooltipDisabledCover: Phaser.GameObjects.Image;
	public interactionHitbox: Phaser.GameObjects.Image;
	public tooltipBacking: Phaser.GameObjects.NineSlice;
	public tooltipText: Phaser.GameObjects.BitmapText;
	public helpIcon: Phaser.GameObjects.Image;
	public settingTooltip: Phaser.GameObjects.Container;
	public buttonLabel: string = "";

	/* START-USER-CODE */

  public key: string = '';
  private _controller: RadioButtonController;
  get controller() {
    return this._controller;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
